<template>
  <div class="signin">
    <div id="form">
      <p class="form-title">管理画面ログイン</p>
        <form action="post" @submit.prevent="login">
          <p>メールアドレス</p>
          <p class="mail"><input v-model="email" type="email" name="mail" /></p>
          <p>パスワード</p>
          <p class="pass"><input v-model="password" type="password" name="pass" /></p>
          <p class="submit"><input type="submit" value="ログイン" /></p>
        </form>
    </div>
      <!-- <button @click="logout">ログアウト</button> -->
  </div>
</template>

<script>
import firebase from 'firebase'
import 'firebase/auth'

export default {
  data () {
    return {
      email: '',
      password: ''
    }
  },
  methods: {
    login: function () {
      firebase.auth().signInWithEmailAndPassword(this.email, this.password)
        .then(() => {
          // 成功時の処理
          this.$router.push('/admin/company08')
        })
        .catch((e) => {
          alert('ログインに失敗しました')
          console.log(e)
        })
    },
    logout: function () {
      firebase.auth().signOut()
        .then(() => {
          // 成功時の処理
          alert('ログアウト')
        })
        .catch((e) => {
        })
    }
  }
}
</script>

<style scoped>
#form{
  width: 400px;
  margin: 30px auto;
  padding: 20px;
  border: 1px solid #555;
  }

form p{
    font-size: 14px;
    }

.form-title{
  text-align: center;
  }

.mail,.pass{
  margin-bottom: 20px;
  }

input[type="email"],
input[type="password"] {
  width: 300px;
  padding: 4px;
  font-size: 14px;
  }
.submit{
  text-align: left;
}

/* font */
#form p{
  color: #077685;
  font-weight: bold;
}

#form .form-title{
  font-family: Arial;
  font-size: 30px;
  color: #4eb4c2;
  }

#form {
  -webkit-border-radius: 6px;
  -moz-border-radius: 6px;
  border-radius: 6px;
  -webkit-box-shadow: 0px 1px 10px #488a9e;
  -moz-box-shadow: 0px 1px 10px #488a9e;
  box-shadow: 0px 1px 10px #488a9e;
  border: solid #4eb4c2 1px;
  background: #fafafa;
}

#form .form-title{
  padding-bottom: 6px;
  border-bottom: 2px solid #4eb4c2;
  margin-bottom: 20px;
}

.submit input{
  font-family: Arial;
  color: #ffffff;
  font-size: 16px;
  padding-top: 10px;
  padding-right: 20px;
  padding-bottom: 10px;
  padding-left: 20px;
  text-decoration: none;
  -webkit-border-radius: 10px;
  -moz-border-radius: 10px;
  border-radius: 10px;
  -webkit-box-shadow: 0px 8px 6px #e3e3e3;
  -moz-box-shadow: 0px 8px 6px #e3e3e3;
  box-shadow: 0px 8px 6px #e3e3e3;
  border: solid #f5fdff 4px;
  background: -webkit-gradient(linear, 0 0, 0 100%, from(#61c7e0), to(#418da8));
  background: -moz-linear-gradient(top, #61c7e0, #418da8);
}
.submit input{
  background: #4eb4c2;
  color: #fafafa
}
</style>
